// 智慧检测
import Log from "../view/log";
import SmartDetectionNav from "../view/SmartDetection/SmartDetectionNav";
import SmartDetectionOverView from "../view/SmartDetection/SmartDetectionOverView/SmartDetectionOverView";
import DistributionRoomManage from "../view/SmartDetection/DistributionRoomManagement/DistributionRoomManage";
import DistributionRoomAdd from "../view/SmartDetection/DistributionRoomManagement/DistributionRoomAdd";
import DistributionRoomModify from "../view/SmartDetection/DistributionRoomManagement/DistributionRoomModify";
import SmartDetectionGatewayManage from "../view/SmartDetection/SmartDetectionGatewayManage/SmartDetectionGatewayManage";
import SmartDetectionGatewayAdd from "../view/SmartDetection/SmartDetectionGatewayManage/SmartDetectionGatewayAdd";
import SmartDetectionGatewayModify from "../view/SmartDetection/SmartDetectionGatewayManage/SmartDetectionGatewayModify";
import SmartDetectionEnvironmentGatewayManage from "../view/SmartDetection/SmartDetectionEnvironmentGateway/SmartDetectionEnvironmentGatewayManage";
import SmartDetectionEnvironmentGatewayAdd from "../view/SmartDetection/SmartDetectionEnvironmentGateway/SmartDetectionEnvironmentGatewayAdd";
import SmartDetectionEnvironmentGatewayModify from "../view/SmartDetection/SmartDetectionEnvironmentGateway/SmartDetectionEnvironmentGatewayModify";
import SmartDetectionVoltageGatewayManage from "../view/SmartDetection/SmartDetectionVoltageGateway/SmartDetectionVoltageGatewayManage";
import SmartDetectionVoltageGatewayAdd from "../view/SmartDetection/SmartDetectionVoltageGateway/SmartDetectionVoltageGatewayAdd";
import SmartDetectionVoltageGatewayModify from "../view/SmartDetection/SmartDetectionVoltageGateway/SmartDetectionVoltageGatewayModify";
import SmartDetectionPowerDistributionCabinetManage from "../view/SmartDetection/SmartDetectionPowerDistributionCabinet/SmartDetectionPowerDistributionCabinetManage";
import SmartDetectionPowerDistributionCabinetAdd from "../view/SmartDetection/SmartDetectionPowerDistributionCabinet/SmartDetectionPowerDistributionCabinetAdd";
import SmartDetectionPowerDistributionCabinetModify from "../view/SmartDetection/SmartDetectionPowerDistributionCabinet/SmartDetectionPowerDistributionCabinetModify";
import SmartDetectionProbeManage from "../view/SmartDetection/SmartDetectionProbe/SmartDetectionProbeManage";
import SmartDetectionProbeAdd from "../view/SmartDetection/SmartDetectionProbe/SmartDetectionProbeAdd";
import SmartDetectionProbeAdd2 from "../view/SmartDetection/SmartDetectionProbe/SmartDetectionProbeAdd2";
import SmartDetectionProbeAdd3 from "../view/SmartDetection/SmartDetectionProbe/SmartDetectionProbeAdd3";
import SmartDetectionProbeModify from "../view/SmartDetection/SmartDetectionProbe/SmartDetectionProbeModify";
import SmartDetectionRegulationManage from "../view/SmartDetection/SmartDetectionRegulation/SmartDetectionRegulationManage";
import SmartDetectionRegulationAdd from "../view/SmartDetection/SmartDetectionRegulation/SmartDetectionRegulationAdd";
import SmartDetectionRegulationModify from "../view/SmartDetection/SmartDetectionRegulation/SmartDetectionRegulationModify";
import SmartDetectionEnvironmentalMonitoring from "../view/SmartDetection/SmartDetectionEnvironmentalMonitoring/SmartDetectionEnvironmentalMonitoring";
import SmartDetectionAlarm from "../view/SmartDetection/SmartDetectionAlarm/SmartDetectionAlarm";
import SmartDetectionAlarmRecord from "../view/SmartDetection/SmartDetectionAlarm/SmartDetectionAlarmRecord";
import SmartDetectionAlarmRecordAdd from "../view/SmartDetection/SmartDetectionAlarm/SmartDetectionAlarmRecordAdd";
import SmartDetectionOperationMonitoring from "../view/SmartDetection/SmartDetectionOperationMonitoring/SmartDetectionOperationMonitoring";
import SmartDetectionPumpMonitoring from "../view/SmartDetection/SmartDetectionOperationMonitoring/SmartDetectionPumpMonitoring";
import SmartDetectionStateMonitoring from "../view/SmartDetection/SmartDetectionOperationMonitoring/SmartDetectionStateMonitoring";
import SmartDetectionThresholdMonitoring from "../view/SmartDetection/SmartDetectionOperationMonitoring/SmartDetectionThresholdMonitoring";
import SmartDetectionDeviceState from "../view/SmartDetection/SmartDetectionDeviceState/SmartDetectionDeviceState";

export default [
  /* 智慧检测 */
  {
    path: "/smart_detection_over_view",
    name: "smart-detection-over-view",
    components: {
      default: SmartDetectionNav,
      a: SmartDetectionOverView
    }
  },
  {
    path: "/distribution_room_manage",
    name: "distribution-room-manage",
    components: {
      default: SmartDetectionNav,
      a: DistributionRoomManage
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: "/distribution_room_add",
    name: "distribution-room-add",
    components: {
      default: SmartDetectionNav,
      a: DistributionRoomAdd
    }
  },
  {
    path: "/distribution_room_modify/:id",
    name: "distribution-room-modify",
    components: {
      default: SmartDetectionNav,
      a: DistributionRoomModify
    }
  },
  {
    path: "/smart_detection_gateway_manage",
    name: "smart-detection-gateway-manage",
    components: {
      default: SmartDetectionNav,
      a: SmartDetectionGatewayManage
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: "/smart_detection_gateway_add",
    name: "smart-detection-gateway-add",
    components: {
      default: SmartDetectionNav,
      a: SmartDetectionGatewayAdd
    }
  },
  {
    path: "/smart_detection_gateway_modify/:id",
    name: "smart-detection-gateway-modify",
    components: {
      default: SmartDetectionNav,
      a: SmartDetectionGatewayModify
    }
  },
  {
    path: "/smart_detection_environment_gateway_manage",
    name: "smart-detection-environment-gateway-manage",
    components: {
      default: SmartDetectionNav,
      a: SmartDetectionEnvironmentGatewayManage
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: "/smart_detection_environment_gateway_add",
    name: "smart-detection-environment-gateway-add",
    components: {
      default: SmartDetectionNav,
      a: SmartDetectionEnvironmentGatewayAdd
    }
  },
  {
    path: "/smart_detection_environment_gateway_modify/:id",
    name: "smart-detection-environment-gateway-modify",
    components: {
      default: SmartDetectionNav,
      a: SmartDetectionEnvironmentGatewayModify
    }
  },
  {
    path: "/smart_detection_voltage_gateway_manage",
    name: "smart-detection-voltage-gateway-manage",
    components: {
      default: SmartDetectionNav,
      a: SmartDetectionVoltageGatewayManage
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: "/smart_detection_voltage_gateway_add",
    name: "smart-detection-voltage-gateway-add",
    components: {
      default: SmartDetectionNav,
      a: SmartDetectionVoltageGatewayAdd
    }
  },
  {
    path: "/smart_detection_voltage_gateway_modify/:id",
    name: "smart-detection-voltage-gateway-modify",
    components: {
      default: SmartDetectionNav,
      a: SmartDetectionVoltageGatewayModify
    }
  },
  {
    path: "/smart_detection_power_distribution_cabinet_manage",
    name: "smart-detection-power-distribution-cabinet-manage",
    components: {
      default: SmartDetectionNav,
      a: SmartDetectionPowerDistributionCabinetManage
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: "/smart_detection_power_distribution_cabinet_add",
    name: "smart-detection-power-distribution-cabinet-add",
    components: {
      default: SmartDetectionNav,
      a: SmartDetectionPowerDistributionCabinetAdd
    }
  },
  {
    path: "/smart_detection_power_distribution_cabinet_modify/:id",
    name: "smart-detection-power-distribution-cabinet-modify",
    components: {
      default: SmartDetectionNav,
      a: SmartDetectionPowerDistributionCabinetModify
    }
  },
  {
    path: "/smart_detection_probe_manage",
    name: "smart-detection-probe-manage",
    components: {
      default: SmartDetectionNav,
      a: SmartDetectionProbeManage
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: "/smart_detection_probe_add",
    name: "smart-detection-probe-add",
    components: {
      default: SmartDetectionNav,
      a: SmartDetectionProbeAdd
    }
  },
  {
    path: "/smart_detection_probe_add2",
    name: "smart-detection-probe-add2",
    components: {
      default: SmartDetectionNav,
      a: SmartDetectionProbeAdd2
    }
  },
  {
    path: "/smart_detection_probe_add3",
    name: "smart-detection-probe-add3",
    components: {
      default: SmartDetectionNav,
      a: SmartDetectionProbeAdd3
    }
  },
  {
    path: "/smart_detection_probe_modify",
    name: "smart-detection-probe-modify",
    components: {
      default: SmartDetectionNav,
      a: SmartDetectionProbeModify
    }
  },
  {
    path: "/smart_detection_regulation_manage",
    name: "smart-detection-regulation-manage",
    components: {
      default: SmartDetectionNav,
      a: SmartDetectionRegulationManage
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: "/smart_detection_regulation_add",
    name: "smart-detection-regulation-add",
    components: {
      default: SmartDetectionNav,
      a: SmartDetectionRegulationAdd
    }
  },
  {
    path: "/smart_detection_regulation_modify/:id",
    name: "smart-detection-regulation-modify",
    components: {
      default: SmartDetectionNav,
      a: SmartDetectionRegulationModify
    }
  },
  {
    path: "/smart_detection_environmental_monitoring",
    name: "smart-detection-environmental-monitoring",
    components: {
      default: SmartDetectionNav,
      a: SmartDetectionEnvironmentalMonitoring
    }
  },
  {
    path: "/smart_detection_alarm",
    name: "smart-detection-alarm",
    components: {
      default: SmartDetectionNav,
      a: SmartDetectionAlarm
    }
  },
  {
    path: "/smart_detection_alarm_record",
    name: "smart-detection-alarm-record",
    components: {
      default: SmartDetectionNav,
      a: SmartDetectionAlarmRecord
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: "/smart_detection_alarm_record_add",
    name: "smart-detection-alarm-record-add",
    components: {
      default: SmartDetectionNav,
      a: SmartDetectionAlarmRecordAdd
    }
  },
  {
    path: "/smart_detection_operation_monitoring",
    name: "smart-detection-operation-monitoring",
    components: {
      default: SmartDetectionNav,
      a: SmartDetectionOperationMonitoring
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: "/smart_detection_pump_monitoring",
    name: "smart-detection-pump-monitoring",
    components: {
      default: SmartDetectionNav,
      a: SmartDetectionPumpMonitoring
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: "/smart_detection_state_monitoring",
    name: "smart-detection-state-monitoring",
    components: {
      default: SmartDetectionNav,
      a: SmartDetectionStateMonitoring
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: "/smart_detection_threshold_monitoring",
    name: "smart-detection-threshold-monitoring",
    components: {
      default: SmartDetectionNav,
      a: SmartDetectionThresholdMonitoring
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: "/smart_detection_device_state",
    name: "smart-detection-device-state",
    components: {
      default: SmartDetectionNav,
      a: SmartDetectionDeviceState
    },
    meta: {
      keepAlive: true
    }
  },
  /* 智慧检测 */
  // 智慧检测操作日志
  {
    path: "/smart_detection_log",
    name: "smart-detection-log",
    components: {
      default: SmartDetectionNav,
      a: Log
    }
  }
];



// WEBPACK FOOTER //
// ./src/router/SmartDetection.js